import { render, staticRenderFns } from "./DocumentationDiv.vue?vue&type=template&id=676d7d1f&"
import script from "./DocumentationDiv.vue?vue&type=script&lang=js&"
export * from "./DocumentationDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports